import { render } from "./platformAddDialog.vue?vue&type=template&id=8affcca2"
import script from "./platformAddDialog.vue?vue&type=script&lang=js"
export * from "./platformAddDialog.vue?vue&type=script&lang=js"

import "./platformAddDialog.vue?vue&type=style&index=0&id=8affcca2&lang=css"

import exportComponent from "E:\\Apangu\\TdServerMiniAppPortalWeb\\TdServerMiniAppPortalWeb\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__